export * from '@primeuix/themes/aura/virtualscroller';
export { default } from '@primeuix/themes/aura/virtualscroller';
